"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.states = void 0;
const statesList = [
    { usps_code: 'AL', text: 'Alabama' },
    { usps_code: 'AK', text: 'Alaska' },
    { usps_code: 'AS', text: 'American Samoa' },
    { usps_code: 'AR', text: 'Arkansas' },
    { usps_code: 'AZ', text: 'Arizona' },
    { usps_code: 'CA', text: 'California' },
    { usps_code: 'CO', text: 'Colorado' },
    { usps_code: 'CT', text: 'Connecticut' },
    { usps_code: 'DC', text: 'Washington D.C.' },
    { usps_code: 'DE', text: 'Delaware' },
    { usps_code: 'FM', text: 'Federated States of Micronesia' },
    { usps_code: 'FL', text: 'Florida' },
    { usps_code: 'GA', text: 'Georgia' },
    { usps_code: 'GU', text: 'Guam' },
    { usps_code: 'HI', text: 'Hawaii' },
    { usps_code: 'ID', text: 'Idaho' },
    { usps_code: 'IL', text: 'Illinois' },
    { usps_code: 'IN', text: 'Indiana' },
    { usps_code: 'IA', text: 'Iowa' },
    { usps_code: 'KS', text: 'Kansas' },
    { usps_code: 'KY', text: 'Kentucky' },
    { usps_code: 'LA', text: 'Louisiana' },
    { usps_code: 'MA', text: 'Massachusetts' },
    { usps_code: 'MD', text: 'Maryland' },
    { usps_code: 'ME', text: 'Maine' },
    { usps_code: 'MH', text: 'Marshall Islands' },
    { usps_code: 'MI', text: 'Michigan' },
    { usps_code: 'MN', text: 'Minnesota' },
    { usps_code: 'MO', text: 'Missouri' },
    { usps_code: 'MP', text: 'Northern Mariana Islands' },
    { usps_code: 'MS', text: 'Mississippi' },
    { usps_code: 'MT', text: 'Montana' },
    { usps_code: 'NE', text: 'Nebraska' },
    { usps_code: 'NV', text: 'Nevada' },
    { usps_code: 'NH', text: 'New Hampshire' },
    { usps_code: 'NJ', text: 'New Jersey' },
    { usps_code: 'NM', text: 'New Mexico' },
    { usps_code: 'NY', text: 'New York' },
    { usps_code: 'NC', text: 'North Carolina' },
    { usps_code: 'ND', text: 'North Dakota' },
    { usps_code: 'OH', text: 'Ohio' },
    { usps_code: 'OK', text: 'Oklahoma' },
    { usps_code: 'OR', text: 'Oregon' },
    { usps_code: 'PA', text: 'Pennsylvania' },
    { usps_code: 'PR', text: 'Puerto Rico' },
    { usps_code: 'PW', text: 'Palau' },
    { usps_code: 'RI', text: 'Rhode Island' },
    { usps_code: 'SC', text: 'South Carolina' },
    { usps_code: 'SD', text: 'South Dakota' },
    { usps_code: 'TN', text: 'Tennessee' },
    { usps_code: 'TX', text: 'Texas' },
    { usps_code: 'UT', text: 'Utah' },
    { usps_code: 'UM', text: 'U.S. Minor Outlying Islands' },
    { usps_code: 'VT', text: 'Vermont' },
    { usps_code: 'VA', text: 'Virginia' },
    { usps_code: 'VI', text: 'Virgin Islands' },
    { usps_code: 'WA', text: 'Washington' },
    { usps_code: 'WV', text: 'West Virginia' },
    { usps_code: 'WI', text: 'Wisconsin' },
    { usps_code: 'WY', text: 'Wyoming' },
];
const mappedStates = statesList.reduce((acc, val) => acc.set(val.usps_code, val), new Map());
exports.states = {
    list: statesList,
    mapped: mappedStates,
};
//# sourceMappingURL=geo.js.map